package ru.arty_bikini.crm_frontend

import ru.arty_bikini.crm.dto.work.WorkTypeDTO
import ru.arty_bikini.crm_frontend.network.NetworkModule

class CacheModule(network: NetworkModule) {

    private val dict = network.dict
    private val stone = network.stone
    private val orderData = network.orderData

    //dict
    val trainers = SimpleCache(emptyList()) { dict.getTrainers()?.trainerList?.sortedBy { it.priority }?.filter { it.visible } }
    val productTypes = SimpleCache(emptyList()) { dict.getProductTypes()?.productTypeDTOList?.sortedBy { it.priority }?.filter { it.visible } }
    val rhinestoneTypes = SimpleCache(emptyList()) { dict.getRhinestoneType()?.rhinestoneTypeDTOList?.sortedBy { it.priority }?.filter { it.visible } }
    val calcPresets = SimpleCache(emptyList()) { stone.getPresets()?.calcPresetDTOList?.sortedBy { it.priority } }
    val expressTypes = SimpleCache(emptyList()) { dict.getExpress()?.expressDTOList?.sortedBy { it.minDays } }
    val strapsTypes = SimpleCache(emptyList()) { dict.getStraps()?.strapsDTOList?.sortedBy { it.priority }?.filter { it.visible } }
    val additionalItems = SimpleCache(emptyList()) { dict.getPrice()?.priceDTOS?.sortedBy { it.priority }?.filter { it.visible } }
    val workTypes = SimpleCache(emptyList()) { dict.getWorkTypes()?.workTypeList?.sortedBy { it.priority }?.filter { it.visible } }

    val orderDataTypes = SimpleCache(emptyList()) { orderData.getDataTypes()?.types }
    val measureVariants = SimpleCache(emptyList()) { orderData.getMeasureVariants()?.measureVariantsDTOList?.sortedBy { it.priority } }

}
